export const delay = (milliseconds: number) =>
	new Promise((resolve) => setTimeout(resolve, milliseconds))
